import { getActiveLocale } from '@/ux-common/src/utils/locale';

export function getIsoToUsShortDateTime(
  timeStamp?: string,
  locale?: string
): string {
  let now;

  // If timeStamp is null/undefined, or timeStamp === "", we fall back to current date.
  if (!timeStamp) {
    // coverts both undefined/null and also "" (empty string is falsy)
    now = new Date();
  } else {
    // at this point, timeStamp is a non-empty string
    now = new Date(timeStamp);
  }

  // return empty string if date is invalid
  if (isNaN(now.getTime())) return '';

  const activeLocale = getActiveLocale(locale);

  return new Intl.DateTimeFormat(activeLocale, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(now);
}
